import { defineComponent, onMounted } from 'vue';
import AddCustomProduct from '@/presentation/components/custom-products/add-custom-product/add-custom-product.vue';
import TableAddedProducts from '@/presentation/components/custom-products/table-added-products/table-added-products.vue';
import CustomBudgetBreakdown from '@/presentation/components/custom-products/custom-budget-breakdown/custom-budget-breakdown.vue';
import CustomProductModal from '@/presentation/components/custom-products/custom-product-modal/custom-product-modal.vue';
import CustomProductsCode from '@/presentation/pages/custom-products/custom-products.code';

export default defineComponent({
	components: {
		AddCustomProduct,
		TableAddedProducts,
		CustomBudgetBreakdown,
		CustomProductModal
	},
	setup: () => {
		const code = new CustomProductsCode();

		onMounted(code.mounted.bind(code));

		return {
			customProductModalActive: code.customProductModalActive,
			selectedCustomProductName: code.selectedCustomProductName,
			selectedCustomProductDescription: code.selectedCustomProductDescription,
			selectedCustomProductPrice: code.selectedCustomProductPrice,
			selectedCustomProductDate: code.selectedCustomProductDate,
			resetSelectedValues: code.resetSelectedValues.bind(code)
		};
	}
});
